import { render, staticRenderFns } from "./SentView.vue?vue&type=template&id=1435e28c&scoped=true"
import script from "./SentView.vue?vue&type=script&lang=js"
export * from "./SentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1435e28c",
  null
  
)

export default component.exports